var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 125,
    viewBox: "0 0 120 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.847 45.9538C106.96 45.9538 108.672 44.24 108.672 42.1259C108.672 40.0117 106.96 38.2979 104.847 38.2979C102.735 38.2979 101.023 40.0117 101.023 42.1259C101.023 44.24 102.735 45.9538 104.847 45.9538Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25348 66.655C4.64312 66.655 5.76965 65.5275 5.76965 64.1366C5.76965 62.7457 4.64312 61.6182 3.25348 61.6182C1.86383 61.6182 0.737305 62.7457 0.737305 64.1366C0.737305 65.5275 1.86383 66.655 3.25348 66.655Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8199 111.931C16.2095 111.931 17.3361 110.804 17.3361 109.413C17.3361 108.022 16.2095 106.894 14.8199 106.894C13.4302 106.894 12.3037 108.022 12.3037 109.413C12.3037 110.804 13.4302 111.931 14.8199 111.931Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2705 111.931L63.5795 100.867V55.5059L28.2705 66.4846V111.931Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8881 111.931L63.5791 100.867V55.5059L98.8881 66.4846V111.931Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5795 123.08L28.2705 112.016V66.6543L63.5795 77.7182V123.08Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 123.08L98.8881 112.016V66.6543L63.5791 77.7182V123.08Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 55.5056L46.978 43.0801L11.0791 55.1652L28.2701 66.4843L63.5791 55.5056Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5791 55.5056L80.1802 43.0801L116.079 55.1652L98.8881 66.4843L63.5791 55.5056Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2701 66.6543L63.5791 77.7182L45.9667 88.9522L11.0791 77.3777L28.2701 66.6543Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8881 66.6543L63.5791 77.7182L81.1915 88.9522L116.079 77.3777L98.8881 66.6543Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4311 11.957C78.3777 25.3815 79.8521 28.3643 80.336 41.5922C80.1499 44.6117 80.0344 47.8951 78.6108 50.539C76.7097 54.5834 72.0597 57.3844 67.6664 57.4298C63.1404 57.5106 58.7033 54.7395 56.7062 50.4664C55.3011 47.8731 55.3458 44.3258 57.2732 41.9713C59.3685 39.7131 63.0547 39.1501 65.7064 40.561C68.6233 41.901 70.3643 44.6872 71.0092 47.6255C71.654 50.5638 71.3707 53.7508 70.5836 56.6484C68.9373 63.6959 67.5738 64.0368 63.5365 75.9686",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 4.85144C79.4397 6.82542 77.6027 8.03411 75.2732 7.40382C72.8204 6.98571 71.0845 6.55478 70.9727 4.79299C71.029 2.98619 73.0003 2.27904 75.3076 1.48189C78.0742 0.382576 79.2947 2.92246 79.4512 4.85144Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6016 10.8879C64.8447 12.1676 67.4654 12.5407 68.7425 10.5861C70.1428 8.41929 71.3415 6.84404 70.0537 5.39723C68.8106 4.1176 67.6009 4.97912 64.8343 6.07844C62.6166 7.20994 62.1458 9.48609 63.6016 10.8879Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3375 2.72259C70.4688 2.24043 71.8239 2.59416 72.4286 3.50725C72.6862 3.79661 72.9885 4.25316 73.0781 4.58752C74.0409 6.83804 73.7382 9.0692 72.4389 9.59636C71.0164 10.3357 69.0566 9.06887 68.3065 6.94052C68.1274 6.2718 68.0378 5.93744 67.9035 5.4359C67.7581 4.22064 68.2062 3.20475 69.3375 2.72259C69.5055 2.67759 69.3375 2.72259 69.3375 2.72259Z",
    fill: "#F1F3F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3375 2.72259C70.4688 2.24043 71.8239 2.59416 72.4286 3.50725C72.6862 3.79661 72.9885 4.25316 73.0781 4.58752C74.0409 6.83804 73.7382 9.0692 72.4389 9.59636C71.0164 10.3357 69.0566 9.06887 68.3065 6.94052C68.1274 6.2718 68.0378 5.93744 67.9035 5.4359C67.7581 4.22064 68.2062 3.20475 69.3375 2.72259ZM69.3375 2.72259C69.3375 2.72259 69.5055 2.67759 69.3375 2.72259V2.72259Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3364 38.9508H15.1463V36.7607H13.2691V38.9508H11.0791V40.8905H13.2691V43.0806H15.1463V40.8905H17.3364V38.9508Z",
    fill: "#AAB2C5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1468 93.897H19.9568V91.707H18.0796V93.897H15.8896V95.8368H18.0796V98.0268H19.9568V95.8368H22.1468V93.897Z",
    fill: "#AAB2C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.885 94.0211L115.205 92.6683L116.558 89.9887L114.261 88.8291L112.908 91.5087L110.229 90.1558L109.031 92.5291L111.71 93.882L110.357 96.5615L112.654 97.7211L114.007 95.0416L116.687 96.3945L117.885 94.0211Z",
    fill: "#AAB2C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.94bea0fd817f8e12835fcba7512f5b67.svg";
export { ForwardRef as ReactComponent };